/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The Meal model module.
 * @module model/Meal
 * @version 1.0.0
 */
export default class Meal {
  /**
   * Constructs a new <code>Meal</code>.
   * @alias module:model/Meal
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>Meal</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Meal} obj Optional instance to populate.
   * @return {module:model/Meal} The populated <code>Meal</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Meal()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String')
      }
      if (data.hasOwnProperty('unit_price')) {
        obj['unit_price'] = ApiClient.convertToType(data['unit_price'], 'Number')
      }
      if (data.hasOwnProperty('sale_unit')) {
        obj['sale_unit'] = ApiClient.convertToType(data['sale_unit'], 'String')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {String} name
   */
  name = undefined
  /**
   * @member {Number} unit_price
   */
  unit_price = undefined
  /**
   * @member {module:model/Meal.SaleUnitEnum} sale_unit
   */
  sale_unit = undefined

  /**
   * Allowed values for the <code>sale_unit</code> property.
   * @enum {String}
   * @readonly
   */
  static SaleUnitEnum = {
    /**
     * value: "people_stay"
     * @const
     */
    people_stay: 'people_stay',

    /**
     * value: "people"
     * @const
     */
    people: 'people',

    /**
     * value: "stay"
     * @const
     */
    stay: 'stay',

    /**
     * value: "once"
     * @const
     */
    once: 'once'
  }
}
